import { ToggleButton } from "@mui/material";
import { ApplicationTooltip } from "../views/ApplicationTooltip";

type ModuleButtonProps = {
    tooltipText: React.ReactElement | string;
    disabled: boolean;
    onChanged: () => void;
    onContextMenu?: React.MouseEventHandler<HTMLButtonElement>;
    children: React.ReactElement;
};

export function ToolsPanelButton({
    tooltipText,
    disabled,
    onChanged,
    onContextMenu,
    children,
}: ModuleButtonProps) {
    return (
        <ApplicationTooltip
            title={tooltipText}
            placement='bottom-start'
        >
            <span style={{ display: 'inline-flex' }}>
                <ToggleButton
                    value="check"
                    selected={true}
                    onChange={onChanged}
                    onContextMenu={onContextMenu}
                    sx={{
                        borderColor: "#9e9d9d",
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        '&.Mui-disabled': {
                            color: '#828282',
                        },
                        height: '5px',
                        width: '5px',
                    }}
                    disabled={disabled}
                >
                    {children}
                </ToggleButton>
            </span>
        </ApplicationTooltip>
    );
}
